import { useGetQuery, useGetQueryCollection } from 'shared/lib/api';

import type {
  CampaignHistoryModel,
  ContractorHistoryModel,
  CrmHistoryModel,
  GroupHistoryModel,
  InvoiceHistoryModel,
  LeadOrAppointmentHistoryModel,
} from '../model';

import { historyRoutes } from './routes';

export const useGetManagerSaleHistory = (id: number) =>
  useGetQuery<LeadOrAppointmentHistoryModel[]>(historyRoutes.internal.getSaleHistory, {
    urlParams: { id },
  });

export const useGetManagerLeadHistory = (id: number) =>
  useGetQuery<LeadOrAppointmentHistoryModel[]>(historyRoutes.internal.getLeadHistory, {
    cacheTime: 0,
    urlParams: { id },
  });

export const useGetManagerAppointmentHistory = (id: number) =>
  useGetQueryCollection<LeadOrAppointmentHistoryModel>(historyRoutes.internal.getAppointmentHistory, {
    urlParams: {
      id,
    },
  });

export const useGetContractorHistory = (id: number) =>
  useGetQuery<ContractorHistoryModel[]>(historyRoutes.internal.getContractorHistory, {
    urlParams: { id },
    cacheTime: 0,
  });

export const useGetManagerSaleCrmHistory = (id: number) =>
  useGetQuery<CrmHistoryModel[]>(historyRoutes.internal.getSaleCrmHistory, {
    cacheTime: 0,
    urlParams: { id },
  });

export const useGetManagerCrmHistory = (id: number) =>
  useGetQuery<CrmHistoryModel[]>(historyRoutes.internal.getLeadCrmHistory, {
    cacheTime: 0,
    urlParams: { id },
  });

export function useGetCampaignHistory(id: number) {
  return useGetQuery<CampaignHistoryModel[]>(historyRoutes.internal.getCampaignHistory, {
    urlParams: { id },
    cacheTime: 0,
  });
}

export function useGetGroupHistory(id: number) {
  return useGetQuery<GroupHistoryModel[]>(historyRoutes.internal.getGroupHistory, {
    urlParams: { id },
    cacheTime: 0,
  });
}

export function useGetInvoiceHistory(id: number) {
  return useGetQuery<InvoiceHistoryModel[]>(historyRoutes.internal.getInvoiceHistory, {
    urlParams: { id },
    cacheTime: 0,
  });
}
